<div [ngClass]="classes" [attr.id]="player.id" *ngIf="image">
    <img class="base-img" [src]="source" alt="">
</div>
<div [ngClass]="classes" *ngIf="placeholder">
    <span>{{buildNameBackground(player)}}</span>
</div>